import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/i18n/LangContext";

const setLink = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

export const usePageMeta = (title, description, keywords, image) => {
  const { lang } = useLang();
  const { pathname } = useLocation();
  useEffect(() => {
    if (!title) return;
    const url = window.location.origin + pathname;
    setLink('link[rel="canonical"]', { rel: "canonical", href: lang === "es" ? `${url}?lang=es` : url });
    setLink('link[hreflang="en"]', { rel: "alternate", hreflang: "en", href: url });
    setLink('link[hreflang="es"]', { rel: "alternate", hreflang: "es", href: `${url}?lang=es` });
    setLink('link[hreflang="x-default"]', { rel: "alternate", hreflang: "x-default", href: url });
    setMeta("property", "og:locale", lang === "es" ? "es_NI" : "en_US");
    setMeta("property", "og:url", url);
    if (image) setMeta("property", "og:image", image.startsWith("http") ? image : window.location.origin + image);
    document.title = `${title} | Dr. Cora Baltodano Nicaragua`;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    setMeta("property", "og:title", title);
    if (keywords) setMeta("name", "keywords", keywords);
    setMeta("name", "robots", "index, follow, max-image-preview:large");
    setMeta("property", "og:type", pathname.startsWith("/blog/") ? "article" : "website");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    if (description) setMeta("name", "twitter:description", description);
    const crumbs = [{ name: lang === "es" ? "Inicio" : "Home", url: window.location.origin + "/" }];
    if (pathname !== "/") crumbs.push({ name: title, url });
    let ld = document.getElementById("ld-breadcrumb");
    if (!ld) {
      ld = document.createElement("script");
      ld.type = "application/ld+json";
      ld.id = "ld-breadcrumb";
      document.head.appendChild(ld);
    }
    ld.text = JSON.stringify({ "@context": "https://schema.org", "@type": "BreadcrumbList", itemListElement: crumbs.map((c, i) => ({ "@type": "ListItem", position: i + 1, name: c.name, item: c.url })) });
  }, [title, description, keywords, image, lang, pathname]);
};
